import React from "react";
import { createRoot } from "react-dom/client";
import ErrorBoundary from "./components/ErrorBoundary";

import App from "./App";
import "./I18n";
import "./styles/phone-input.css";

// Listener global pour la navigation depuis les notifications push
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data?.type === 'NAVIGATE' && event.data.url) {
      if (process.env.NODE_ENV === 'development') {
        console.log('[PUSH] Navigation vers:', event.data.url);
      }
      window.location.href = event.data.url;
    }
  });
}

try {
  const container = document.getElementById("root") as HTMLElement;

  if (!container) {
    throw new Error("Root element not found. Check your HTML.");
  }

  const root = createRoot(container);

  root.render(
    <React.StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </React.StrictMode>
  );
} catch (error) {
  console.error("Fatal error during application start:", error);

  // Afficher une erreur visible pour l'utilisateur
  const errorDiv = document.createElement("div");
  errorDiv.innerHTML = `
    <div style="color: red; padding: 20px; text-align: center; font-family: Arial;">
      <h2>Erreur de démarrage</h2>
      <p>L'application n'a pas pu démarrer correctement.</p>
      <button onclick="window.location.reload()">Rafraîchir</button>
    </div>
  `;
  document.body.appendChild(errorDiv);
}
